import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { ContextMenuItem as ArcContextMenuItem, ContextMenuItemProps, styled, cssVar } from 'arc';
import { useApplicationType } from '../../../common/hooks/use-application-type';

const EnlargedContextMenuItem = styled(ArcContextMenuItem)`
    font-size: ${cssVar('arc.fontSizes.lg')};
    height: ${cssVar('arc.sizes.12')};
`;

export const ContextMenuItem = forwardRef(function (
    props: ContextMenuItemProps,
    ref?: React.Ref<HTMLElement>
) {
    const { isCad } = useApplicationType();

    if (isCad) {
        return (
            <ArcContextMenuItem ref={ref} {...props}>
                {props.children}
            </ArcContextMenuItem>
        );
    }

    return (
        // <div> is needed for menu list layout
        <div>
            <EnlargedContextMenuItem ref={ref} {...props}>
                {props.children}
            </EnlargedContextMenuItem>
        </div>
    );
});
